import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {AppService} from './app.service';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {CardDesignerComponent} from './CardDesigner/cardDesigner.component';
import {AccountComponent} from './Account/account.component';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {HeaderComponent} from './Header/header.component';
import {CardControllerComponent} from './CardController/cardController.component';
import {ErrorModalComponent} from './Modals/ErrorModal/errorModal.component';
import {PictureThisComponent} from './PictureThisGame/PictureThis.component';
import {CustomInterceptor} from './CustomInterceptor';
import {LocationComponent} from './LocationOptions/location.component';
import {ImpressionsComponent} from './Impressions/impressions.component';
import {AdminConsoleComponent} from './AdminConsole/adminConsole.component';
import {SponsorConsoleComponent} from './SponsorConsole/sponsorConsole.component';
import {CreateConsoleComponent} from './CreateConsole/createConsole.component';
import {CustomComponent} from './CustomSetup/custom.component';
import {DatePipe, HashLocationStrategy, LocationStrategy} from '@angular/common';
import {HomePageComponent} from './HomePage/homePage.component';
import { MainComponent } from './main/main.component';
import { BetaPageComponent } from './beta-page/beta-page.component';
import {appRouting} from './app.routing';
import { LoginPageComponent } from './login-page/login-page.component';
import { FooterComponent } from './footer/footer.component';
import { VerifyPageComponent } from './verify-page/verify-page.component';
import {CardDesignerMobileComponent} from './CardDesginerMobile/cardDesignerMobile.component';
import {CreateConsoleMobileComponent} from './CreateConsoleMobile/createConsoleMobile.component';
import {CardControllerMobileComponent} from "./CardControllerMobile/cardControllerMobile.component";
import {LocationMobileComponent} from "./LocationOptionsMobile/locationMobile.component";
import {ImpressionsMobileComponent} from "./ImpressionsMobile/impressionsMobile.component";
import {CustomMobileComponent} from "./CustomSetupMobile/customMobile.component";
import {SponsorConsoleMobileComponent} from "./SponsorConsoleMobile/sponsorConsoleMobile.component";
import {CardCreatorComponent} from "./CardCreator/cardCreator.component";
import {CardCreatorMobileComponent} from "./CardCreatorMobile/cardCreatorMobile.component";
import {CardSaveTypeModalComponent} from "./Modals/CardSaveTypeModal/cardSaveTypeModal.component";

@NgModule({
    declarations: [
        AppComponent,
        CardDesignerComponent,
        CardDesignerMobileComponent,
        AccountComponent,
        HeaderComponent,
        CardControllerComponent,
        CardControllerMobileComponent,
        ErrorModalComponent,
        CardSaveTypeModalComponent,
        PictureThisComponent,
        LocationComponent,
        LocationMobileComponent,
        ImpressionsComponent,
        ImpressionsMobileComponent,
        AdminConsoleComponent,
        SponsorConsoleComponent,
        SponsorConsoleMobileComponent,
        HomePageComponent,
        CreateConsoleComponent,
        CreateConsoleMobileComponent,
        CustomComponent,
        CustomMobileComponent,
        MainComponent,
        BetaPageComponent,
        LoginPageComponent,
        FooterComponent,
        VerifyPageComponent,
        CardCreatorComponent,
        CardCreatorMobileComponent
    ],
  imports: [
    appRouting,
    BrowserModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule.forRoot()
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CustomInterceptor,
      multi: true
    },
    {provide: LocationStrategy, useClass: HashLocationStrategy},
    AppService,
    DatePipe
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
